import React from 'react'
import Header from "../components/header/clientHeader";
import { useNavigate } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
function NotFound() {
    const navigate = useNavigate();
  return (
    <div className='w-full h-screen'>
        <Header value="" justView={true}>
            {/* Add div */}
        <div className="h-screen w-screen md:w-full md:h-screen bg-blue-7 grid justify-items-center items-center pl-2 pr-2 pt-2 pb-10 md:pl-56 md:pr-56  md:pt-10">
            <div className='w-auto h-auto pl-6 pt-2 pr-10 pb-8 md:pl-20 md:pr-20 md:pt-10 md:pb-10'>
            <div className='mt-6 md:mt-4'>
                <h1>Remote Software engineers</h1>
            </div>
            <div className='mt-6 md:mt-4 '>
                <h1 className='md:text-4xl text-2xl font-bold font-Poppins'>All the candiates initially shared with you have been placed</h1>
            </div>
            <div className='grid grid-cols-12 mt-8 mb-4'>
                <div className="col-span-5">
                    <button className='bg-pink-1 text-white-1 rounded-sm p-2 w-60' onClick={() => {navigate(`/form`);  mixpanel.track('Request for new list')}}>Request new candidates</button>        
                </div>
            </div>
            </div>
        </div>
        </Header>
    </div>
  )
}

export default NotFound